<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ChartsLine',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      required: true
    }
  },
  watch: {
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      const xAxisData = this.data.map((item) => item.date)
      const seriesData = this.data.map((item) => item.count)

      // let showEchart = false
      // let namenum = 0
      // if (xAxisData) {
      //   if (xAxisData.length > 0) {
      //     // namenum = Math.floor(100 / (xAxisData.length / 10))
      //     if (xAxisData.length > 10) {
      //       showEchart = true
      //     } else {
      //       showEchart = false
      //     }
      //   }
      // }
      const option = {
        // 标题
        title: {
          text: this.title,
          left: 'center',
          top: 15,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
            // color: '#000'
          }
        },
        // 工具提示
        tooltip: {
          trigger: 'axis',
          formatter: '{b} <br/>{a} : {c}',
          axisPointer: {
            type: 'line'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: (value) => {
              // return value.min
              return Math.floor(value.min / 100) * 100
            },
            max: (value) => {
              return Math.ceil(value.max)
              // return Math.ceil(value.max / 100) * 100
            }
          }
        ],
        // 颜色配置
        color: ['#667eea'],
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     realtime: true,
        //     start: 0,
        //     end: namenum, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
        //     height: 5, //组件高度
        //     left: 5, //左边的距离
        //     right: 5, //右边的距离
        //     bottom: 10, //下边的距离
        //     show: showEchart, // 是否展示
        //     fillerColor: 'rgba(17, 100, 210, 0.42)', // 滚动条颜色
        //     borderColor: 'rgba(17, 100, 210, 0.12)',
        //     handleSize: 0, //两边手柄尺寸
        //     showDetail: false, //拖拽时是否展示滚动条两侧的文字
        //     zoomLock: true, //是否只平移不缩放
        //     moveOnMouseMove: false, //鼠标移动能触发数据窗口平移
        //     //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放

        //     //下面是自己发现的一个问题，当点击滚动条横向拖拽拉长滚动条时，会出现文字重叠，导致效果很不好，以此用下面四个属性进行设置，当拖拽时，始终保持显示六个柱状图，可结合自己情况进行设置。添加这个属性前后的对比见**图二**
        //     startValue: 0, // 从头开始。
        //     endValue: 6, // 最多六个
        //     minValueSpan: 10, // 放大到最少几个
        //     maxValueSpan: 10 //  缩小到最多几个
        //   },
        //   {
        //     type: 'inside', // 支持内部鼠标滚动平移
        //     start: 0,
        //     end: namenum,
        //     zoomOnMouseWheel: false, // 关闭滚轮缩放
        //     moveOnMouseWheel: true, // 开启滚轮平移
        //     moveOnMouseMove: true // 鼠标移动能触发数据窗口平移
        //   }
        // ],
        // 类型配置
        series: [
          {
            name: '设备数量',
            // 类型配置
            type: 'line',
            // 数据配置
            data: seriesData,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  fontSize: 14,
                  position: 'top',
                  formatter: '{c}'
                }
              }
            }
          }
        ]
      }
      mychart.setOption(option)
    }
  }
}
</script>

<style lang="less"></style>
